import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { User } from '@/core/models/user';
import { Outlet } from '@/core/models/outlet';
import { Entity } from '@/core/models/login';

export interface OpenClientConnectPayload {
  client: Entity;
  outlet?: Outlet | null;
  user: User;
}

@Injectable({ providedIn: 'root' })
export class ClientsTreeCoordinatorService {
  readonly openedClientId$ = new Subject<number | null>();
  readonly openedOutletId$ = new Subject<number | null>();
  readonly openChat$ = new Subject<OpenClientConnectPayload>();
  readonly openChatList$ = new Subject<void>();
  readonly toggleChatList$ = new Subject<void>();
  readonly reloadUsersForClient$ = new Subject<number>();

  openClient(clientId: number): void {
    this.openedClientId$.next(clientId);
  }

  openOutlet(outletId: number): void {
    this.openedOutletId$.next(outletId);
  }

  openChat(payload: OpenClientConnectPayload): void {
    this.openChat$.next(payload);
  }

  openChatList(): void {
    this.openChatList$.next();
  }

  toggleChatList(): void {
    this.toggleChatList$.next();
  }

  reloadUsersForClient(clientId: number): void {
    this.reloadUsersForClient$.next(clientId);
  }
}
